import React from 'react';

export default function AuthLayout({ children }) {
    return (
        <div className="min-h-screen bg-[#3b82f6] flex items-center justify-center p-4">
            {children}
        </div>
    );
}